import { MouseEventHandler, PropsWithChildren } from 'react';

// eslint-disable-next-line no-restricted-imports
import { generatePath } from 'react-router-dom';
import { PropsWithTestAttribute } from 'types/testAttribute';

import { ParamsType } from '../types';

import { LinkStyled } from './Link.styles';

/**
 * Props for the Link component.
 * @template Path - The route path type.
 */
export interface LinkProps<Path extends string> {
  /**  The target route path. */
  to: Path;

  /** Parameters for the route path (if applicable). */
  params: ParamsType<Path> | undefined;

  className?: string;

  onClick?: MouseEventHandler<HTMLAnchorElement>;
}

/**
 * Link component that generates the correct path with parameters.
 * @template T - The route path type.
 */
export const Link = <T extends string>({
  to,
  params,
  children,
  className,
  onClick,
  datax,
}: LinkProps<T> & PropsWithChildren & PropsWithTestAttribute) => {
  // Generate the path with parameters
  const path = generatePath(to, params);
  // Render the Link component
  return (
    <LinkStyled className={className} datax={datax} to={path} onClick={onClick}>
      {children}
    </LinkStyled>
  );
};
